import { render, staticRenderFns } from "./edit-2026.vue?vue&type=template&id=3fc4e079&scoped=true"
import script from "./edit-2026.vue?vue&type=script&lang=js"
export * from "./edit-2026.vue?vue&type=script&lang=js"
import style0 from "./edit-2026.vue?vue&type=style&index=0&id=3fc4e079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc4e079",
  null
  
)

export default component.exports